import React, { useState } from "react";
import { Table, Tag, Switch, Button, Space, Input, Grid } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const { useBreakpoint } = Grid;

export default function DomainTable() {
  const [searchText, setSearchText] = useState("");
  const screens = useBreakpoint();

  const columns = [
    {
      title: "Domain name",
      dataIndex: "domain",
      key: "domain",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) =>
        status === "pending" ? (
          <Tag color="orange">Pending verification</Tag>
        ) : (
          <Tag color="#3985f0ff">Active</Tag>
        ),
    },
    {
      title: "Expiration date",
      dataIndex: "expiry",
      key: "expiry",
      responsive: ["md"],
      render: (expiry) => expiry || "-",
    },
    {
      title: "Auto-renewal",
      dataIndex: "auto",
      key: "auto",
      responsive: ["lg"],
      render: (auto) =>
        auto !== null ? <Switch size="small" defaultChecked={auto} /> : "-",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space wrap size="small">
          {record.status === "pending" ? (
            <Button type="primary" size="small">
              Verify
            </Button>
          ) : (
            <>
              <Button size="small">Renew</Button>
              <Button size="small">Manage</Button>
            </>
          )}
        </Space>
      ),
    },
  ];

  const allData = [
    { key: "1", domain: "kashdeals.in", status: "pending", expiry: null, auto: null },
    { key: "2", domain: "kashdeals.com", status: "active", expiry: "2026-06-10", auto: true },
    { key: "3", domain: "zainabmodesty.com", status: "active", expiry: "2026-04-23", auto: false },
    { key: "4", domain: "dastkaarhandicraftsppc.com", status: "active", expiry: "2026-04-10", auto: false },
    { key: "5", domain: "trailandtrainvacations.com", status: "active", expiry: "2026-03-22", auto: false },
    { key: "6", domain: "abdisposableindustry.com", status: "active", expiry: "2026-03-22", auto: false },
    { key: "7", domain: "csclaundries.com", status: "active", expiry: "2026-01-24", auto: false },
    { key: "8", domain: "defconinnovations.xyz", status: "active", expiry: "2026-01-23", auto: false },
    { key: "9", domain: "defconinnovations.cloud", status: "active", expiry: "2026-01-22", auto: false },
  ];

  const filteredData = allData.filter((item) =>
    item.domain.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div
      style={{
        background: "#fff",
        padding: 20,
        borderRadius: 12,
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      }}
    >
      <h2 style={{ marginBottom: 20 }}>Domain Portfolio</h2>

      {/* Search + Add Domain */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          marginBottom: 20,
        }}
      >
        <Input
          size="large"
          placeholder="Search..."
          prefix={<SearchOutlined />}
          style={{ flex: 1, minWidth: 220, borderRadius: 8 }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

        <Button
          type="primary"
          size="large"
          style={{
            background: "#4f57f6",
            borderRadius: 8,
            padding: "0 20px",
            whiteSpace: "nowrap",
          }}
        >
          Add Domain
        </Button>
      </div>

      {/* Responsive Table / Card View */}
      {screens.md ? (
        <Table
          columns={columns}
          dataSource={filteredData}
          pagination={false}
          rowSelection={{}}
          scroll={{ x: "max-content" }}
          size="middle"
        />
      ) : (
        // Mobile card layout
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {filteredData.map((item) => (
            <div
              key={item.key}
              style={{
                padding: 12,
                borderRadius: 8,
                boxShadow: "0 1px 5px rgba(0,0,0,0.05)",
                background: "#f9f9f9",
              }}
            >
              <div style={{ fontWeight: 600, marginBottom: 6 }}>{item.domain}</div>
              <div>Status: {item.status === "pending" ? "Pending" : "Active"}</div>
              <div>Expiry: {item.expiry || "-"}</div>
              <div>
                Auto-renewal:{" "}
                {item.auto !== null ? (item.auto ? "Yes" : "No") : "-"}
              </div>
              <div style={{ marginTop: 6 }}>
                <Space wrap size="small">
                  {item.status === "pending" ? (
                    <Button type="primary" size="small">
                      Verify
                    </Button>
                  ) : (
                    <>
                      <Button size="small">Renew</Button>
                      <Button size="small">Manage</Button>
                    </>
                  )}
                </Space>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
